import { Navigate, createFileRoute } from '@tanstack/react-router';

import { resolveDeniedRoute } from '../features/auth/accessPolicy';
import { ShigoPermission } from '../features/auth/permissions';
import { useShigoPermissions } from '../features/auth/useShigoPermissions';

export const Route = createFileRoute('/a2v/')({
  component: A2vIndexRoute,
});

function A2vIndexRoute() {
  const { can, permissions } = useShigoPermissions();
  if (can(ShigoPermission.A2vAssetsRead)) {
    return <Navigate to="/a2v/assets" replace />;
  }
  if (can(ShigoPermission.A2vNetworkTemplateRead)) {
    return <Navigate to="/a2v/network-template" replace />;
  }

  const fallback = resolveDeniedRoute(permissions, '/a2v');
  return fallback ? <Navigate to={fallback} replace /> : null;
}
